// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type { TCreateMessageRequest, TCreateMessageModel, IMappers, TCreateMessageResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IMessageCreatorResult } from '../../entities/base_creator_result_message/MessageCreatorResult';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createCreateMessageModel(parameters: TCreateMessageRequest): TCreateMessageModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'demand',
    pathApi: '/v5/create-message/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ICreateMessageOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TCreateMessageRequest;
}

export async function fetchCreateMessage<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICreateMessageOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TCreateMessageResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCreateMessageModel(parameters),
    config,
  )) as FetchResponse<TCreateMessageResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IMessageCreatorResult, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCreateMessageResponse>;
}
